<template>
    <slide-x-left-transition :duration="400+(index*100)" :delay="200+(index*100)">
        <ion-card v-if="show" mode="ios" :disabled="!available || passed">
            <img :src="image" style="width: 100%; height: auto"/>
            <ion-item>
                <ion-label mode="md" class="ion-text-wrap">
                    <ion-badge v-if="passed">
                        <svg class="icon icon-checkmark"><use xlink:href="#icon-checkmark"></use></svg>
                        <span>Egzamin rozwiązany</span>
                    </ion-badge>
                    <h2>{{ name }}</h2>
                </ion-label>
            </ion-item>
            <ion-card-content style="text-align:left">
                <p v-if="!examPossible" style="padding-top: 10px">Aby przystąpić do egzaminu musisz zdać wszystkie testy z tego poziomu.</p>
                <ion-button mode="ios"
                            fill="outline"
                            size="small"
                            class="mt-10"
                            @click="goTo('TrainingExam', level_slug)"
                            :disabled="!examPossible">Rozwiąż egzamin
                </ion-button>
            </ion-card-content>
        </ion-card>
    </slide-x-left-transition>
</template>

<script>
    import goTo from '@/mixins/goto';
    import { mapGetters, mapState } from 'vuex';

    export default {
        name: 'ItemTrainingExam',
        props: ['index', 'slug', 'level_slug', 'name', 'image', 'passed', 'available'],
        mixins: [goTo],
        data() {
            return {
                show: false
            }
        },
        mounted() {
            this.show = true;
        },
        computed: {
            ...mapState({
                lessons: state => state.trainings.lessons
            }),

            // count passed_test flag in every lesson
            examPossible(){
                return this.lessons.every(lesson => lesson.passed_test === true) ? true : false
            }
        }
    }
</script>

<style lang="scss" scoped>
    ion-card{
        margin: 0 0 20px 0px;
        border-radius: 0;
    }
    ion-card-content{
        padding: 0 20px 15px 15px;
    }
</style>